import { Observable } from 'rxjs';
import { BaseGridResponse } from '../../data/shared/base-grid.response';
import { BaseRequest } from '../../data/shared/base.request';
import { CommittedOrder, GetCommittedOrderRequest } from '../domain';

export abstract class CommittedOrdersRepository {

  abstract getCommittedOrders(request: BaseRequest<GetCommittedOrderRequest>): Observable<BaseGridResponse<CommittedOrder>>;

}
